import { Injectable } from '@angular/core';
import { AccessToken } from '@app/core/authentication/models/access-token.model';
import { SerializingHttpClient } from '@webmozarts/http-client';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AuthenticationService {

    constructor(private http: SerializingHttpClient) {
    }

    login(username: string, password: string): Observable<AccessToken> {
        return this.http
            .post(
                AccessToken,
                '/authentication/login',
                {
                    username,
                    password,
                },
            );
    }
}
